import { app } from '@beastshop/browser'
import bridge from '@beastshop/bridge'
(function() {
  function install(Vue) {
    let title = function(title) {
      if(app()){
        bridge.setTitle(title)
      }
      if(typeof title === 'object'){
        return
      }
      document.title = title
      
      this.$nextTick(() => {
        this._emit && this._emit('change-title', title)
      })
    }
    Vue.mixin({
      created: function() {
        this.$setTitle = title
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = install
  } else if (typeof define == "function" && define.amd) {
    define([], function() {
      return install
    })
  } else if (window.Vue) {
    Vue.use(install)
  }

})()



// WEBPACK FOOTER //
// ./static/plugins/set-title/index.js